module.exports = __webpack_public_path__ + "static/media/logo-full-city-goddess.6ef4ffec.png";